import { default as React, useEffect, useContext, useState } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import Content from "./content";
import httpService from "core/infrastructure/http";
import { MaxNetPosDto, GetMaxNetPosResponse, MaxExchangesDto, GetMaxExchangesResponse, GetCheckVolumeQuery } from "core/backend/data";
import ContentPart from "components/contentPart";
import SheetHeader from "components/sheetHeader";
import { ApplicationState } from "core/app";
import { keys } from "ts-transformer-keys";
import { PageList } from "core/pages/pageList";

interface OwnState {
    applicationState: ApplicationState;
}
export const senderId = "coreMarketView";
export const page_config: PageList =
{
    apiUrl: "",
    webUrl: "coreMarketView",
    menu: "menu:menuCoreMarketView",
    title: "menu:titleCoreMarketView",
    apiType: "data",
    response: "",
    dto: "",
    parameters: "",
    dateSteps: "H",
    getDefaultToDateTime: (applicationState: ApplicationState) => applicationState.getUntilFor1Hour()
};

type PageProps = OwnState & WithTranslation;

const Page = ({ t, applicationState }: PageProps) => {

    if (!applicationState.initialized) return <div />;

    const initialMaxNetPosData: MaxNetPosDto[] = [];
    const [maxNetPosData, setMaxNetPosData] = useState(initialMaxNetPosData);
    const initialMaxExchangesData: MaxExchangesDto[] = [];
    const [maxExchangesData, setMaxExchangesData] = useState(initialMaxExchangesData);
    const [isLoading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [loadedDate, setLoadedDate] = useState("");


    const loadMaxNetPos = async () => {
        const response = await httpService.apiPost<GetMaxNetPosResponse>({
            applicationState: applicationState,
            route: applicationState.apiService + "/" + page_config.apiType + "/maxNetPos",
            query: {
                FromUtc: applicationState.getRootUtcTime().toISOString(),
                ToUtc: applicationState.getUntilFor1Day().toISOString()
            },
            senderId: senderId
        })();

        if (response.ok) {
            setMaxNetPosData(response.data.data);
            setError("");
        } else {
            setError(response.error || t("common:UnknownError"));
        }
    };
    const loadMaxExchanges = async () => {
        const response = await httpService.apiPost<GetMaxExchangesResponse>({
            applicationState: applicationState,
            route: applicationState.apiService + "/" + page_config.apiType + "/maxExchanges",
            query: {
                FromUtc: applicationState.getRootUtcTime().toISOString(),
                ToUtc: applicationState.getUntilFor1Day().toISOString()
            },
            senderId: senderId
        })();

        if (response.ok) {
            setMaxExchangesData(response.data.data);
            setError("");
        } else {
            setError(response.error || t("common:UnknownError"));
        }
    };

    const dtoHubKeys: string[] = keys<GetCheckVolumeQuery>()
        .filter(f => f.startsWith("hub_"));

    const dtoBorderKeys: string[] = keys<MaxExchangesDto>()
        .filter(f => f.startsWith("border_"));

    useEffect(() => {
        (async function runAsync() {
            applicationState.handleInputAvailablilityChange(page_config.dateSteps, false, false, dtoHubKeys.concat(dtoBorderKeys));
            //setLoading(true);
            const date = applicationState.getRootUtcTime().toISOString();
            if (loadedDate !== date) {
                setMaxNetPosData([]);
                setMaxExchangesData([]);
                //we cannot use Promis.All to request both data at the same time because of IP LIMIT
                /*await Promise.all([
                    loadMaxNetPos(),
                    loadMaxExchanges(),
                ]);*/
                await loadMaxNetPos();
                await loadMaxExchanges();

                setLoadedDate(date);
            }
            setLoading(false);
        })();
    }, [applicationState.selectedDate]);
    const abc = {} as MaxNetPosDto;
    return (
        <>
            <SheetHeader showDownload={false} applicationState={applicationState} title={t(page_config.title)} pageConfig={page_config} />
            <ContentPart isLoading={isLoading} data={[]} error={error}>
                <Content applicationState={applicationState}
                    maxNetPosData={maxNetPosData.filter(f => new Date(f.dateTimeUtc).toISOString() === applicationState.selectedDate.toISOString())[0] || undefined}
                    maxExchangeData={maxExchangesData.filter(f => new Date(f.dateTimeUtc).toISOString() === applicationState.selectedDate.toISOString())[0] || undefined}
                />
            </ContentPart>
        </>
    );
};

export default withTranslation()(Page);
